import { MachineHistory } from 'models/MachineHistory';
import { MachineHistoryActionType } from 'redux/actions/machines/MachineHistoryActions';
import { LoginUserActionType } from 'redux/actions/LoginUserActions';

interface loginReturnPayload {
    expiration: string
    token: string,
}

function replaceDateInMachineHistory(mh: MachineHistory): MachineHistory {
    let mappedMh = Object.assign({}, mh);
    mappedMh.date = new Date(mh.date);
    return mappedMh;
}

export function mapIncoming(sucAction: string, payload: any): any {
    switch (sucAction) {
        case LoginUserActionType.LOGIN_USER_SUCCESS:
        case LoginUserActionType.REGISTER_USER_SUCCESS:
        case LoginUserActionType.SETNEW_PASSWORD_SUCCESS:
            {
                const resp = payload as loginReturnPayload
                return { token: resp.token };
            }
        case MachineHistoryActionType.ADD_MACHINEHISTORY_SUCCESS:
        case MachineHistoryActionType.EDIT_MACHINEHISTORY_SUCCESS:
            {
                let resp = payload as MachineHistory;
                resp.date = new Date(resp.date);
                return { returnPayload: resp };
            }
        case MachineHistoryActionType.FETCH_MACHINEHISTORIES_SUCCESS:
            {
                return { returnPayload: (payload as MachineHistory[]).map(r => replaceDateInMachineHistory(r)) };
            }
        default:
            return { returnPayload: payload };
    }
}